import { tv } from '@/utils/libs/tailwind-variants';
/**
 * 見出しテキストの variant class を生成する関数
 * @note 使用箇所が多いため、関数を直接使用してOK
 */
export const headStyle = tv({
    base: [],
    /**
     * 各種 プロパティ + class 定義
     */
    variants: {
        /** 色 */
        color: {
            base: 'text-base',
            inactive: 'text-inactive',
            link: 'text-link',
            primary: 'text-primary',
            white: 'text-white',
        },
        /** フォント */
        fontFamily: {
            alpha: 'font-alpha',
            base: 'font-display',
            serif: 'font-serif',
        },
        /** 太さ */
        isBold: {
            false: 'font-normal',
            true: 'font-bold',
        },
        /** 大きさ */
        size: {
            /* eslint-disable sort-keys-fix/sort-keys-fix */
            xxxl: 'text-head-xxxl',
            xxl: 'text-head-xxl',
            xl: 'text-head-xl',
            lg: 'text-head-lg',
            md: 'text-head-md',
            sm: 'text-head-sm',
            xs: 'text-head-xs',
            xxs: 'text-head-xxs',
            /* eslint-enable sort-keys-fix/sort-keys-fix */
        },
    },
}, {
    responsiveVariants: true,
});
